function ctrl($scope, generateId, $q, $http, fetchStream, $stateParams, $location, $window) {
    let model = this; // used to assign functions and methods to master controller
    // DEFAULT VARIABLES
    let updateInterval = 60000; // used with the update timer
    model.searchCategories = {}; // holds dropdown search modifiers
    let defaultDayRange = 1;
    model.manualSearch = false;

    model.safeApply = function (fn) {
        let phase = $scope.$root.$$phase;
        if (phase == '$apply' || phase == '$digest') {
            if (fn && (typeof(fn) === 'function')) {
                fn();
            }
        } else {
            $scope.$apply(fn);
        }
    };

    //////////////////////////////////////////////////////////////////////////////////////////////
    // THIS IS THE CONTROLLER FOR THE MAIN MASTER WRAPPER. BELOW ARE METHODS THAT FUCK SHIT UP. //
    //////////////////////////////////////////////////////////////////////////////////////////////

    //////////////////////////
    ///////    TIME    ///////
    //////////////////////////
    // by default we'll set the time to to the default day range
    model.time = {
        start: Math.round(new Date().getTime() / 1000)-((3600*24)*defaultDayRange),
        end: Math.round(new Date().getTime() / 1000)
    }
    model.getTime = function () {
        let t;
        if (($location.$$search.hasOwnProperty('start')) && ($location.$$search.hasOwnProperty('end'))) {
            t = {
                start: $location.$$search.start,
                end: $location.$$search.end
            }
        } else {
            t = model.time;
        }
        return t;
    }
    model.setTime = function (newTime) {
        return $q(function (resolve, reject) {
            // do nothing if the new time doesnt have start or end
            if (!(newTime.hasOwnProperty('start')) && !(newTime.hasOwnProperty('end'))) { return reject(); }
            model.time.start = newTime.start;
            model.time.end = newTime.end;
            return resolve(Object.create(model.time));
            // return resolve({start: Object.create(model.time).start, end: Object.create(model.time).end});
        })
    }
    model.rollTime = function (miliseconds) { // NOTE: values in our time object is rounded so the value inputed may need to be shorter
        return $q(function (resolve) {
            let oldTime = Object.create(model.getTime());
            let newTime = {
                start: oldTime.start + (miliseconds / 1000),
                end: oldTime.end + (miliseconds / 1000)
            }
            model.setTime(newTime);
            return resolve({ current: newTime, old: oldTime });
        })
    }

    //////////////////////////////
    ///////    UPDATING    ///////
    //////////////////////////////
    // dimension and group builder
    model.buildDimGroup = function (rows, identifiers) {
        let deferred = $q.defer();
        // stop if there is no grouping defined in the settings
        if (!model.dataObjects[identifiers.key].settings) {
            deferred.reject();
        } else if (!model.dataObjects[identifiers.key].settings.hasOwnProperty('grouping')) {
            deferred.reject();
        } else if (rows.length > 0) {
            // set it as launched.. do it right away in case notify comes back sooner and runs this twice
            model.dataObjects[identifiers.key].launched = true;
            function run(callback) {
                // set values that dont get reduced on
                let dontReduceOn = [
                    'basic_constraints_path_len',
                    'bucket',
                    'cert_count',
                    'certificate_exponent',
                    'certificate_key_length',
                    'certificate_not_valid_after',
                    'certificate_not_valid_before',
                    'certificate_version',
                    'cyrin_confidence',
                    'cyrin_id',
                    'cyrin_severity',
                    'depth',
                    'desktop_height',
                    'desktop_width',
                    'duration',
                    'events_id',
                    'first_seen',
                    'get_bulk_requests',
                    'get_requests',
                    'get_responses',
                    'group',
                    'hour',
                    'ioc_alert',
                    'ioc_child',
                    'ioc_severity',
                    'last_seen',
                    'orig_asn',
                    'orig_lat',
                    'orig_long',
                    'orig_port',
                    'orig_user',
                    'p',
                    'port_num',
                    'qclass',
                    'qtype',
                    'qtype_name',
                    'rcode',
                    'reply_code',
                    'resp_asn',
                    'resp_lat',
                    'resp_long',
                    'resp_port',
                    'resp_user',
                    'request_body_len',
                    'response',
                    'response_body_len',
                    'response_to',
                    'rounded',
                    'serial',
                    'set_requests',
                    'status_code',
                    'suppress_for',
                    'till',
                    'time',
                    'top_domain',
                    'trans_depth',
                    'trans_id',
                    'type',
                    'ttls',
                    'version',
                    'z',
                ];
                let initialData = { visible: false };
                if (typeof rows[0] === 'object') {
                    for (let c in rows[0]) {
                        if (rows[0][c] === null || typeof rows[0][c] === "string" || _.isNaN(Number(rows[0][c]))) {
                            initialData[c] = null;
                        } else {
                            initialData[c] = 0;
                        }
                    }
                }
                // this function compiles our dimension function
                let compileDim = function (groupby) {
                    let dimString = '(function (cfObj) { return cfObj.dimension(function (d) { \n';
                    dimString += 'return ';
                    for (let d = 0, dlen = groupby.length; d < dlen; d++) {
                        dimString += 'd.'+groupby[d];
                        if (d !== (dlen-1)) {
                            dimString += ' + ';
                        }
                    }
                    dimString += ';\n';
                    dimString += '}) })\n';
                    return eval(dimString)
                }
                // set the dimension into the settings object for this viz
                model.dataObjects[identifiers.key].settings.dimension = compileDim(model.dataObjects[identifiers.key].settings.grouping);
                // compile the actual dimension in crossfilter
                model.dataObjects[identifiers.key].dimension = model.dataObjects[identifiers.key].settings.dimension(model.dataObjects[identifiers.key].cf);
                // generate grouping
                let compileGroup = function (initial) {
                    let groupString = '(function (dimension) { return dimension.group().reduce(\n'
                    groupString += 'function(p, v) { \n';
                    groupString += 'if (v.time > p.time) {\n';
                    groupString += '    p.time = v.time;\n'; // always take newest time
                    groupString += '} else {\n';
                    groupString += '    v.time = p.time\n';
                    groupString += '}\n';

                    for (let g in initial) {
                        if ((g === 'time') || (typeof initial[g] !== 'number') || (dontReduceOn.indexOf(g) !== -1)) {
                            groupString += 'p.'+g+' = v.'+g+';\n';
                        } else {
                            groupString += 'p.'+g+' += v.'+g+';\n';
                        }
                    }

                    groupString += 'p.visible = true;\n';
                    groupString += 'return p\n';
                    groupString += '},\n';
                    groupString += 'function(p, v) { \n';
                    for (let g in initial) {
                        if ((g === 'time') || (typeof initial[g] !== 'number') || (dontReduceOn.indexOf(g) !== -1)) {
                            groupString += 'p.'+g+' = v.'+g+';\n';
                        } else {
                            groupString += 'p.'+g+' -= v.'+g+';\n';
                        }
                    }
                    groupString += 'if (v.time > p.time) {\n';
                    groupString += '    p.time = v.time;\n'; // always take newest time
                    groupString += '}\n';
                    groupString += 'p.visible = true;\n';
                    groupString += 'return p\n';
                    groupString += '},\n';
                    groupString += 'function(p) { \n';
                    // groupString += 'if (typeof p === "undefined") { return {} } \n';
                    groupString += 'return '+JSON.stringify(initial)+';\n';
                    groupString += '}) })\n';
                    return eval(groupString);
                }
                // compile the grouping function
                model.dataObjects[identifiers.key].settings.group = compileGroup(initialData);
                // set column spec for refrence when doing searches
                model.dataObjects[identifiers.key].settings.columnSpec = initialData;
                // insert grouping tinto crossfilter
                model.dataObjects[identifiers.key].group = model.dataObjects[identifiers.key].settings.group(model.dataObjects[identifiers.key].dimension);
                // SPEED / REDRAW SETTINGS for items (mostly tables) that only have id as group
                if ((model.dataObjects[identifiers.key].settings.grouping[0] === 'id') && (model.dataObjects[identifiers.key].settings.grouping.length === 1)) {
                    model.dataObjects[identifiers.key].settings.render = { once: true, has: false }
                }
                return callback();
            }
            run(function () {
                return deferred.resolve();
            });
        }
        return deferred.promise;
    }
    // updates the data in a visual using the main url in settings and also takes a param for specific time
    let updateData = function (time, options) {
        let deferred = $q.defer();
        function build(callback) {
            // compile the function list for each data element
            let funString = '';
            for (let d in model.dataObjects) {
                if (!model.dataObjects[d].settings) { continue } // continue if settings are null
                let call = model.dataObjects[d].settings.get.call;
                let params = false; // no parameters by default
                // check for manual options defined
                if (!options) {
                    // if (!model.dataObjects[d].launched) { continue }
                    // skip if not a manual call + is not set to refresh
                    if (!model.dataObjects[d].settings.refresh) { continue }
                } else if (typeof options === 'object') {
                    // otherwise use the options in our query
                    if (options.hasOwnProperty('call')) {
                        call = options.call;
                    }
                    if (options.hasOwnProperty('params')) {
                        params = JSON.stringify(options.params);
                    }
                } else {
                    continue; // failsafe is to do nothing
                }
                let tt;
                let id = model.dataObjects[d].settings.id;
                let key = model.vizDictionary[id];
                if (model.dataObjects[d].time.max) {
                    tt = {}; // set tt as an object
                    tt.start = model.dataObjects[key].time.max;
                    tt.end = time.end;
                    tt = JSON.stringify(tt);
                } else {
                    tt = JSON.stringify(time);
                }
                let fun = '(function () {\n'; // make an empty string for each individaul data obj
                // check to see if a max exists.. and then earch from there instead (if time is rolling)
                fun += '    new fetchStream("'+call+'", model.dataObjects["'+key+'"].settings.get.socket, '+params+', '+tt+')\n';
                fun += '    .then(function (result) {\n';
                fun += '        runFilters();\n';
                fun += '    },\n';
                fun += '    function (err) {\n';

                fun += '    },\n';
                fun += '    function (result) {\n';
                fun += '        model.dataObjects["'+key+'"].cf.add(result.rows);\n';
                                // if unlaunched, check for dim/ group in settings and build if they dont exist (they will already be built in the controller if the settings exist)
                fun += '        if (!model.dataObjects["'+key+'"].launched) {\n';
                fun += '            if ((!model.dataObjects["'+key+'"].settings.hasOwnProperty("group")) && (!model.dataObjects["'+key+'"].settings.hasOwnProperty("dimension"))) {\n';
                                    // with our first data return, we can build dimensions and groups for our data
                fun += '                model.buildDimGroup(result.rows, { id: "'+id+'", key: "'+key+'" }).then(function () {\n';
                                        // initalize rows
                fun += '                    $scope.$broadcast("init", { id: "'+id+'", key: "'+key+'" });\n';
                fun += '                }, function (err) {\n';
                fun += '                    console.log("error")\n';
                fun += '                    console.log(err)\n';
                fun += '                })\n';
                fun += '            }\n';
                fun += '        }\n';
                // fun += '            runFilters();\n';
                // fun += '            if (result.rows.length > 0) {\n';
                fun += '        $scope.$broadcast("updatedData", "'+id+'");\n';
                // fun += '            }\n';
                fun += '        \n';
                fun += '    });\n';
                fun += '})();\n';
                // add our completed function string to the total to be executed
                funString += fun;
                funString += '\n'; // add new line for shits
            }
            let updateFunctionBlock = eval(funString);
        }
        build(function () {
            return deferred.resolve();
        })
        return deferred.promise;
    }
    // begin timer on load to tell child controller when to update
    model.timer = false; // this isnt the same as the timer variable. this holds the timer
    // start refresh timer on load
    let setTimer = function () {
        model.timer = setInterval(function () {
            // figure out and set time difference
            model.rollTime(updateInterval).then(function (timeReturn) {
                // filter out old data
                for (let m in model.dataObjects) {
                    if (!model.dataObjects[m].launched) { continue }
                    if (!model.dataObjects[m].settings.refresh) { continue }
                    // set last max.. this becomes our new start time if it exists
                    let topArr = [];
                    if (model.dataObjects[m].time.dimension) {
                        topArr = model.dataObjects[m].time.dimension.top(1);
                    }
                    if (topArr.length > 0) { // this sets our max time only if there is data
                        if (topArr[0].hasOwnProperty('time')) { // make sure the object contains time
                            model.dataObjects[m].time.max = (parseInt(topArr[0].time)+1); // NOTE: +1 is assed here so we dont get any old records
                        }
                    }
                }
                runFilters(); // update filters from filterstores
                return model.clearOldData(timeReturn.current);
            }).then(function (time) {
                // fetch new data and stuff it
                return updateData(time);
            }).then(function () {
                // console.log('done refresh')
            })
        }, updateInterval)
    };
    // pass it current time and it will filter out items that are passed
    model.clearOldData = function (time) {
        let deferred = $q.defer();
        function loop(time, callback) {
            for (let m in model.dataObjects) {
                if (!model.dataObjects[m].launched) { continue }
                if (!model.dataObjects[m].settings.refresh) { continue }
                model.dataObjects[m].searchDimension.filterAll(); // clear the search dimension
                // refilter down to what needs to be removed
                model.dataObjects[m].searchDimension.filter(function (d, i) {
                    return (d.time < time.start); // isolate time less than our current start
                });
                // delete the data that has been filtered
                model.dataObjects[m].cf.remove();
                // clear the filter again
                model.dataObjects[m].searchDimension.filterAll();
            }
            return callback(time);
        }
        loop(time, function (time) {
            return deferred.resolve(time);
        })
        return deferred.promise;
    }
    model.manualQuery = function (time, options) {
        return updateData(time, options);
    }
    // fired when manually changing date range
    model.manualUpdateTime = function (time) {
        // kill timer
        if (model.timer) {
            clearInterval(model.timer);
        }
        // set time object'
        model.setTime(time)
        .then(function (time) {
            for (let m in model.dataObjects) {
                if (!model.dataObjects[m].launched) { continue }
                // if (!model.dataObjects[m].settings.refresh) { continue }
                // reset the maxTime value
                model.dataObjects[m].time.max = false;
                model.dataObjects[m].searchDimension.filterAll(); // clear the search dimension
                // delete the data that has been filtered
                model.dataObjects[m].cf.remove();
                $scope.$broadcast("redraw", model.dataObjects[m].settings.id);
            }
            // get our data now
            return updateData(time);
        })
    }
    model.resetTimer = function () {
        if (model.timer) {
            clearInterval(model.timer);
        }
        if (!($location.$$search.hasOwnProperty('start')) && !($location.$$search.hasOwnProperty('end'))) {
            setTimer();
        }
    }
    model.resetTimer();
    //////////////////////////////
    /////// DATA MANAGMENT ///////
    //////////////////////////////
    let active = 0;
    model.vizDictionary = {},
    model.dataObjects = {
        d0: {
            cf: new crossfilter([]),
            dimension: false,
            searchDimension: false,
            group: false,
            filters: {
                include: [],
                exclude: []
            },
            settings: null,
            launched: false,
            time: {
                max: false,
                dimension: false
            }
        },
        d1: {
            cf: new crossfilter([]),
            dimension: false,
            searchDimension: false,
            group: false,
            filters: {
                include: [],
                exclude: []
            },
            settings: null,
            launched: false,
            time: {
                max: false,
                dimension: false
            }
        },
        d2: {
            cf: new crossfilter([]),
            dimension: false,
            searchDimension: false,
            group: false,
            filters: {
                include: [],
                exclude: []
            },
            settings: null,
            launched: false,
            time: {
                max: false,
                dimension: false
            }
        },
        d3: {
            cf: new crossfilter([]),
            dimension: false,
            searchDimension: false,
            group: false,
            filters: {
                include: [],
                exclude: []
            },
            settings: null,
            launched: false,
            time: {
                max: false,
                dimension: false
            }
        },
    };
    let increaseActive = function () {
        active++;
    }
    model.registerVisual = function (settings) {
        return $q(function (resolve) {
            // genrate unique id
            let id = generateId();
            let s = 'd'+active; // get next key name (e.g. 'd3')
            // create new data object if we dont have enough
            if (active >= 4) {
                // if nothing is in the 'slot', create new object
                if (typeof model.dataObjects[s] === 'undefined') {
                    model.dataObjects[s] = { cf: new crossfilter([]), dimension: false, searchDimension: false, group: false, filters: { include: [], exclude: [] }, settings: null, launched: false, time: { max: false, dimension: false } };
                }
            }
            model.dataObjects[s].settings = settings; // set settings in the data object for access later
            model.dataObjects[s].settings.id = id; // save the id in the set for other 'main' functions (i.e. filtering)
            model.vizDictionary[id] = s; // record the data key with the unique id for lookup in child controller
            // add search categories to main search categories object if it exists in this visual's settings
            if ((typeof settings.searchCategories !== 'undefined') && (typeof settings.searchCategories !== false)) {
                for (let i in settings.searchCategories) {
                    // push unique search categories to the searchCategories object
                    if (!model.searchCategories.hasOwnProperty(i)) {
                        model.searchCategories[i] = settings.searchCategories[i];
                    }
                }
            }
            // add search dimension for every searchable visual
            model.dataObjects[s].searchDimension = model.dataObjects[s].cf.dimension(function (d) { return d }); // this'll be also used for data streaming, so its outside the rule below
            if ((typeof settings.searchable !== 'undefined') && (typeof settings.searchable !== false)) {
                model.dataObjects[s].time.dimension = model.dataObjects[s].cf.dimension(function (d) { return +d.time });
                model.dataObjects[s].uniqueItems = function (key) {
                    return $q(function (resolve) {
                        let dim = model.dataObjects[s].cf.dimension(function (d) { return d[key] });
                        let group = dim.group();
                        let all = group.all().map(function (d) {
                            return d.key;
                        });
                        group.dispose(); // destory the group we just created
                        dim.dispose();
                        resolve(all);
                    })
                }
            }
            // setup streaming group reduce
            increaseActive(); // increase active # for next register
            resolve({id: id, 'key': s, settings: settings});
        });
    }
    let unregisterVisuals = function () {
        let deffer = $q.defer();
        function run(callback) {
            let current = 0;
            // clear or delete used data objects
            for (let i in model.dataObjects) {
                if (!model.dataObjects[i].settings) { continue } // skip any item item without settings
                if (!model.vizDictionary.hasOwnProperty(model.dataObjects[i].settings.id)) { continue } // skip any items not in our viz dictionary
                if (current <= 3) {
                    if (model.dataObjects[i].dimension) {
                        model.dataObjects[i].dimension.filterAll(); // clear all filters
                        // model.dataObjects[i].dimension.dispose();
                    }
                    model.dataObjects[i].dimension = false; // destroy dimension
                    model.dataObjects[i].group = false; // destroy group
                    model.dataObjects[i].filters = { include: [], exclude: [] }; // destroy filters
                    model.dataObjects[i].settings = null; // destroy settings
                    model.dataObjects[i].launched = false; // reset launched status
                    // clear time related dimensions
                    if (model.dataObjects[i].time.dimension) {
                        model.dataObjects[i].time.dimension.dispose(); // no need to filterAll since the dimension clearing above takes care of that
                    }
                    model.dataObjects[i].time = { max: false, dimension: false }; // reset launched status
                    model.dataObjects[i].cf.remove(); // remove records
                    model.dataObjects[i].cf = new crossfilter([]); // replace cf
                } else {
                // if the are more crossfilter objects than our limit
                    delete model.dataObjects[i]; // remove it
                }
                current++;
            }
            // runFilters();
            model.vizDictionary = {}; // clear lookup dictionary
            active = 0; // clear active visuals
            setTimeout(function () {
                return callback();
            }, 0)
        }
        run(function () {
            return deffer.resolve();
        })
        return deffer.promise;
    }

    //////////////////////////////
    ////////// FILTERING /////////
    //////////////////////////////
    // controller should be listening for individual filter events, but here should be where the dimension objects are looped through
    model.filterItem = function (key, value, action, title) {
        model.updateFilterStore(key, value, action, true, title); // update existing filters
    }
    // controller should be listening for individual filter events, but here should be where the dimension objects are looped through
    model.filterItemByTime = function (filterTime) {
        for (let i in model.dataObjects) {
            if ((!model.dataObjects[i].launched) || (model.dataObjects[i].settings.get.call === "linechart") || (model.dataObjects[i].settings.get.call === "barchart")) { continue }
            if (model.dataObjects[i].settings.complete) {
                model.dataObjects[i].settings.complete = 0;
            }
            if (typeof $scope.main.dataObjects[i].settings.render !== "undefined") {
                $scope.main.dataObjects[i].settings.render.has = false;
            }

            // let callLength = model.dataObjects[i].settings.get.call.length;
            // clear all filters
            model.dataObjects[i].searchDimension.filterAll();
            model.dataObjects[i].cf.remove();
            function getdataByTime(time, render) {
                if (typeof model.dataObjects[i].settings.get.call === "object") {
                    for (let c in model.dataObjects[i].settings.get.call) {
                        requeryData(model.dataObjects[i].settings.get.call[c], model.dataObjects[i].settings.get.socket, time, model.dataObjects[i].settings.id)
                    }
                } else {
                    requeryData(model.dataObjects[i].settings.get.call, model.dataObjects[i].settings.get.socket, time, model.dataObjects[i].settings.id)
                }
            };
            function requeryData (call, socket, time, id) {
                new fetchStream(call, socket, time).then(function (result) {
                    model.dataObjects[i].settings.complete++;
                    if ((call === "table") || (call === "outbound") || (call === "inbound") || (call === "lateral")) {
                        $scope.$broadcast('updatedData', id, { complete : true });
                    }
                }, function (err) {

                }, function (result) {
                    // add rows
                    model.dataObjects[i].cf.add(result.rows);
                    runFilters();
                    if (result.min) {
                        if ((call === "outbound") || (call === "inbound") || (call === "lateral")) {
                            $scope.$broadcast('updateLoad', result.min, true)
                        } else if (call === "table") {
                            $scope.$broadcast('updateLoad', result.min)
                        }
                    }
                })
            }
            if (filterTime.start !== filterTime.end) {
                getdataByTime(filterTime, true)
            } else {
                getdataByTime(model.getTime(), false)
            }
        }
    }
    function runFilters() {
        function searchDim(filters, obj, index) {
            let dictionary = {};
            let includeRulesToSatisfy = _.size(filters.include), included = 0, result = false;
            for (let i = 0, len = filters.include.length; i < len; i++) {
                let key = Object.keys(filters.include[i])[0];
                if (key === 'all') {
                    for (let o in obj) {
                        if (!obj[o]) { continue } // ignore if null or false
                        let toSearch = obj[o].toString().toLowerCase();
                        if (toSearch.indexOf(filters.include[i][key]) > -1) {
                            included++;
                            if (included > includeRulesToSatisfy) {
                                includeRulesToSatisfy++;
                            }
                            // stop the loop once one item is matched in the all obj
                            break;
                        }
                    }
                } else {
                    if (obj[key]) { // if not null
                        if (obj[key].toString().toLowerCase().indexOf(filters.include[i][key]) > -1) {
                            included++;
                        }
                    }
                }
            }
            if (included === includeRulesToSatisfy) {
                result = true;
            }
            // excluded iems
            for (let i = 0, len = filters.exclude.length; i < len; i++) {
                let key = Object.keys(filters.exclude[i])[0];
                if (key === 'all') {
                    for (let o in obj) {
                        if (!obj[o]) { continue } // ignore if null or false
                        if (obj[o].toString().toLowerCase().indexOf(filters.exclude[i].all) > -1) {
                            result = false
                        }
                    }
                } else {
                    if (obj[key]) { // if not null
                        if (obj[key].toString().toLowerCase().indexOf(filters.exclude[i][key]) > -1) {
                            result = false;
                        }
                    }
                }
            }
            return result;
        }
        for (let i in model.dataObjects) {
            if (!model.dataObjects[i].launched) { continue }
            if (!model.dataObjects[i].settings.refresh) { continue }
            // if ((typeof model.dataObjects[i].searchable === 'undefined') || (typeof model.dataObjects[i].searchable === false)) { continue } // skip if not searchable
            // clear all filters
            model.dataObjects[i].searchDimension.filterAll();
            model.dataObjects[i].dimension.filterAll();
            // build array of keys to exclude
            let excludedKeys = [];
            for (let ex = 0, len = model.dataObjects[i].filters.exclude.length; ex < len; ex++) {
                // get key
                let key = Object.keys(model.dataObjects[i].filters.exclude[ex])[0];
                // check to see if its already pushed
                if (excludedKeys.indexOf(key) === -1) { // push if not in array
                    excludedKeys.push(key);
                }
            }
            model.dataObjects[i].searchDimension.filterFunction(searchDim.bind(null, model.dataObjects[i].filters));
            // send update signal
            $scope.$broadcast('updatedData', model.dataObjects[i].settings.id);
        }
    }
    // expose the external runFilters function to other functions that may use it
    // such as the searchbar
    model.runFilters = function () {
        return runFilters();
    }
    model.runLatFilters = function(filterList){
        $scope.$broadcast('runLatSearch',filterList);
        return
    }

    // function sumply for adding filters
    model.addFilter = function (key, nonLowerCaseValue, action, external, title) {
        if (nonLowerCaseValue === null) { return } // dont execute if value is null
        let value = nonLowerCaseValue.toString().toLowerCase(), include = [], exclude = [], child;
        // ser the child directory to either include or exclude, so code isnt repeated
        switch (action) {
            case 'exclude':
                child = 'exclude';
            break;
            case 'include': // there is no break here on purpose
            default:
                child = 'include';
        }
        // find data objects that can be filtered on these values
        for (let i in model.dataObjects) {
            // skip unlaunched visuals
            // if (!model.dataObjects[i].launched) { continue }
            if (typeof model.dataObjects[i].searchDimension !== 'object') { continue }
            if (model.dataObjects[i].settings === null) { continue }
            // only add filters that are located in that visuals search categories
            // check for existing filters (if there is a match, remove.:. add otherwise)
            let obj = {} // temp object
            obj[key] = value;
            model.dataObjects[i].filters[child].push(obj);
            // if NOT manual search, set the run once 'ran' object to false
            if (!model.manualSearch) {
                // reset the single draw rule ALSO SET IN BUILDGROUP for when the chart updates
                if (typeof model.dataObjects[i].settings.render !== 'undefined') {
                    if ((model.dataObjects[i].settings.render.once) && (model.dataObjects[i].settings.render.has)) {
                        model.dataObjects[i].settings.render.has = false;
                    }
                }
            }
        }
        // send boradcasts based on what external events happened
        if (external) {
            $scope.$broadcast('addSearchBarItem', key, nonLowerCaseValue, action, title);
        }
    }

    model.removeFilter = function (key, nonLowerCaseValue, action, external, title) {
        if (nonLowerCaseValue === null) { return } // dont execute if value is null
        let itemToRemove = false; // we'lll use this to tell us if a searchbar item was added or removed
        let value = nonLowerCaseValue.toString().toLowerCase(), include = [], exclude = [], child;
        // ser the child directory to either include or exclude, so code isnt repeated
        switch (action) {
            case 'exclude':
                child = 'exclude';
            break;
            case 'include': // there is no break here on purpose
            default:
                child = 'include';
        }
        // find data objects that can be filtered on these values
        for (let i in model.dataObjects) {
            // skip unlaunched visuals
            // if (!model.dataObjects[i].launched) { continue }
            if (typeof model.dataObjects[i].searchDimension !== 'object') { continue }
            if (model.dataObjects[i].settings === null) { continue }
            // only add filters that are located in that visuals search categories
            // set the local filters varaible
            // check for existing filters (if there is a match, remove.:. add otherwise)
            let filterIndex = -1;
            for (let f = 0, len = model.dataObjects[i].filters[child].length; f < len; f++) {
                if (model.dataObjects[i].filters[child][f].hasOwnProperty(key)) {
                    if (model.dataObjects[i].filters[child][f][key] === value) {
                        // there is a filter that matches
                        filterIndex = f; // set the value to the index
                    }
                }
            }
            if (filterIndex > -1) {
                model.dataObjects[i].filters[child].splice(filterIndex, 1);
                itemToRemove = true;
            }
            // if NOT manual search, set the run once 'ran' object to false
            if (!model.manualSearch) {
                // reset the single draw rule ALSO SET IN BUILDGROUP for when the chart updates
                if (typeof model.dataObjects[i].settings.render !== 'undefined') {
                    if ((model.dataObjects[i].settings.render.once) && (model.dataObjects[i].settings.render.has)) {
                        model.dataObjects[i].settings.render.has = false;
                    }
                }
            }
        }
        // send boradcasts based on what external events happened
        if (external && itemToRemove) {
            $scope.$broadcast('removeSearchBarItem', key, nonLowerCaseValue, action, title);
        }
    }

    model.clearFilters = function () {
        $scope.$broadcast('clearAllFilters');
    }

    // this function can add filters to the individual datasets filter store AND
    //.. remove them if it is presented with an identical value
    model.updateFilterStore = function (key, nonLowerCaseValue, action, external, title) {
        if (nonLowerCaseValue === null) { return } // dont execute if value is null
        let whatHappened = false; // we'lll use this to tell us if a searchbar item was added or removed
        let value = nonLowerCaseValue.toString().toLowerCase(), include = [], exclude = [], child;
        // ser the child directory to either include or exclude, so code isnt repeated
        switch (action) {
            case 'exclude':
                child = 'exclude';
            break;
            case 'include': // there is no break here on purpose
            default:
                child = 'include';
        }
        // find data objects that can be filtered on these values
        for (let i in model.dataObjects) {
            // skip unlaunched visuals
            // if (!model.dataObjects[i].launched) { continue }
            if (typeof model.dataObjects[i].searchDimension !== 'object') { continue }
            if (model.dataObjects[i].settings === null) { continue }
            // only add filters that are located in that visuals search categories
            // set the local filters varaible
            // check for existing filters (if there is a match, remove.:. add otherwise)
            let filterIndex = -1;
            for (let f = 0, len = model.dataObjects[i].filters[child].length; f < len; f++) {
                if (model.dataObjects[i].filters[child][f].hasOwnProperty(key)) {
                    if (model.dataObjects[i].filters[child][f][key] === value) {
                        // there is a filter that matches
                        filterIndex = f; // set the value to the index
                    }
                }
            }
            if (filterIndex > -1) {
                model.dataObjects[i].filters[child].splice(filterIndex, 1);
                whatHappened = 'itemsRemoved';
            } else {
                let obj = {} // temp object
                obj[key] = value;
                model.dataObjects[i].filters[child].push(obj);
                whatHappened = 'itemsAdded';
            }
            // if NOT manual search, set the run once 'ran' object to false
            if (!model.manualSearch) {
                // reset the single draw rule ALSO SET IN BUILDGROUP for when the chart updates
                if (typeof model.dataObjects[i].settings.render !== 'undefined') {
                    if ((model.dataObjects[i].settings.render.once) && (model.dataObjects[i].settings.render.has)) {
                        model.dataObjects[i].settings.render.has = false;
                    }
                }
            }
        }
        // send boradcasts based on what external events happened
        if ((external) && (whatHappened === 'itemsAdded')) {
            $scope.$broadcast('addSearchBarItem', key, nonLowerCaseValue, action, title);
        } else if ((external) && (whatHappened === 'itemsRemoved')) {
            $scope.$broadcast('removeSearchBarItem', key, nonLowerCaseValue, action, title);
        }
        // stop here if the page's search is manual
        if (model.manualSearch) { $scope.$broadcast('runSearch');return }
        // apply filters
        runFilters();
    }
    model.runManualSearch = function () {
        // change manual search id (blocking all notify data)
        model.manualSearchId = generateId();
        let functions = '';
        // make query
        for (var i in model.dataObjects) {
            // if (!model.dataObjects[i].launched) { continue }
            if (typeof model.dataObjects[i].searchDimension !== 'object') { continue }
            if (model.dataObjects[i].settings === null) { continue }
            let id = model.dataObjects[i].settings.id;

            // for now we'll delete the current data. in the future we'll just temporarily move it somewhere
            model.dataObjects[i].searchDimension.filterAll();
            model.dataObjects[i].cf.remove();
            // reset the single draw rule ALSO SET IN BUILDGROUP for when the chart updates
            if (typeof model.dataObjects[i].settings.render !== 'undefined') {
                if ((model.dataObjects[i].settings.render.once) && (model.dataObjects[i].settings.render.has)) {
                    model.dataObjects[i].settings.render.has = false;
                }
            }
            // redraw
            $scope.$broadcast("updatedData", id); // this will clear the tables on search
            // reset the single draw settings again - TODO: MAKE THIS A FUNCTION
            if (typeof model.dataObjects[i].settings.render !== 'undefined') {
                if ((model.dataObjects[i].settings.render.once) && (model.dataObjects[i].settings.render.has)) {
                    model.dataObjects[i].settings.render.has = false;
                }
            }

            // include sanatize
            let ilen = model.dataObjects[i].filters.include.length, include = [], isAll = false;
            if (ilen > 0) {
                for (let f = 0; f < ilen; f++) {
                    let keys = Object.keys(model.dataObjects[i].filters.include[f]);
                    let key = keys[0];
                    if (model.dataObjects[i].settings.searchCategories.hasOwnProperty(key) || (key === 'all')) {
                        let item = {}
                        item[key] = model.dataObjects[i].filters.include[f][key];
                        include.push(item);
                    }
                    // set all mode if a an item in 'all' exists
                    if (key === 'all') {
                        isAll = true;
                    }
                }
            }
            // excluded items sanatize
            let elen = model.dataObjects[i].filters.exclude.length, exclude = [];
            if (elen > 0) {
                for (let f = 0; f < elen; f++) {
                    let keys = Object.keys(model.dataObjects[i].filters.exclude[f]);
                    let key = keys[0];
                    if (model.dataObjects[i].settings.searchCategories.hasOwnProperty(key)) {
                        let item = {}
                        item[key] = model.dataObjects[i].filters.exclude[f][key];
                        exclude.push(item);
                    }
                }
            }
            // 'ALL' SEARCH
            if (isAll && (typeof model.dataObjects[i].settings.columnSpec !== 'undefined')) {
                // if there are 'all' params, loop through searchCategories and generate an array of columns
                isAll = [];
                for (let f in model.dataObjects[i].settings.searchCategories) {
                    if (model.dataObjects[i].settings.columnSpec[f] === null) { // this takes from initalData in the dim/group builder - we only want strings - numbers are 0
                        isAll.push(f);
                    }
                }
            }

            // PARAMS
            // stringify our params for the
            let time = model.getTime();
            let tt = JSON.stringify(time);
            let key = model.vizDictionary[id];
            let params = JSON.stringify({
                include: include,
                exclude: exclude,
                type: model.dataObjects[i].settings.type,
                reqId: model.manualSearchId,
                // if the loop above finds an 'all' search item in the includes, this will become an array of searchable fields
                allSearch: isAll
            })

            let fun = '(function () {\n'; // make an empty string for each individaul data obj
            // check to see if a max exists.. and then earch from there instead (if time is rolling)
            fun += '    new fetchStream("'+model.dataObjects[key].settings.get.call+'", model.dataObjects["'+key+'"].settings.get.socket, '+params+', '+tt+')\n';
            fun += '    .then(function (result) {\n';
            fun += '        runFilters();\n';
            // fun += '        if (!model.dataObjects["'+key+'"].launched) {\n';
            //                     // after table is set to 'launched', add any items in the killchain to the searchbar and global filters
            //                     // note: we only have includes from kill chain
            // fun += '            model.emptyResponseTryNext(model.currentMode);\n';
            // fun += '        }\n';
            fun += '    },\n';
            fun += '    function (err) {\n';

            fun += '    },\n';
            fun += '    function (result) {\n';
            fun += '        if (result.reqId !== "'+model.manualSearchId+'") { return }\n';
                            // return if any of the filter selects are not part of the return i.e. searching remote_country in DHCP should return nothing
                            for (let inc = 0, incLen = model.dataObjects[i].filters.include.length; inc < incLen; inc++) {
                                let key = Object.keys(model.dataObjects[i].filters.include[inc])[0];
                                if (key !== 'all') {
                                    fun += 'if (Object.keys(result.rows[0]).indexOf("'+key+'") === -1) { console.log("no exist"); return }\n';
                                }
                            }
            fun += '        model.dataObjects["'+key+'"].cf.add(result.rows);\n';
            fun += '        if (!model.dataObjects["'+key+'"].launched) {\n';
                                // with our first data return, we can build dimensions and groups for our data
            fun += '            model.buildDimGroup(result.rows, { id: "'+id+'", key: "'+key+'" }).then(function () {\n';
                                // initalize rows
            fun += '                $scope.$broadcast("init", { id: "'+id+'", key: "'+key+'" });\n';
            fun += '            }, function (err) {\n';
            fun += '                console.log("error")\n';
            fun += '            })\n';
            fun += '        } else if (result.rows.length > 0) {\n';
            fun += '            $scope.$broadcast("updatedData", "'+id+'");\n';
            fun += '        }\n';
            fun += '        \n';
            fun += '    });\n';
            fun += '})();\n';
            functions += fun;
            $scope.$broadcast("manualSearchFired", {key:key, id:id});
        }
        eval(functions);
    }
    // function to set and unset manual search mode
    model.setManualSearch = function (status) {
        model.manualSearch = status;
    }

    //////////////////////////////
    /////////// SEARCH ///////////
    //////////////////////////////
    // main object
    // when a modifier is selected it runs this function that finds the data objects containing data with the same field for the autocomplete
    model.getVals = function (value) {
        if (model.manualSearch) { return } // dont populate value list if manual search is turned on
        let select;
        if (typeof value.select === "undefined") {
            select = value;
        } else {
            select = value.select;
        }
        let deferred = $q.defer();
        let recordsToSearch = [];
        for (let i in model.dataObjects) {
            if (model.dataObjects[i].settings === null) { continue }
            if (typeof model.dataObjects[i].settings.searchCategories === 'undefined') { continue }
            for (let s in model.dataObjects[i].settings.searchCategories) {
                if (select === s) {
                    recordsToSearch.push(i);
                }
            }
        }
        let uniqueValues = [], d = {};
        for (let i = 0, rlen = recordsToSearch.length; i < rlen; i++) {
            model.dataObjects[recordsToSearch[i]].uniqueItems(select).then(function (vals) {
                for (let v = 0, len = vals.length; v < len; v++) {
                    if (d.hasOwnProperty(vals[v])) {
                        continue;
                    }
                    uniqueValues.push(vals[v]);
                    d[vals[v]] = 1;
                }
                if (i === 1) { // send an inital return
                    deferred.resolve(uniqueValues);
                } else {
                    // keep sending updates
                    deferred.notify(uniqueValues);
                }
            })
        }
        return deferred.promise;
    }

    let cleanupSearch = function () {
        model.searchCategories = {};
    }
    // CLEANUP
    model.cleanup = function () {
        let deffer = $q.defer();
        function c(callback) {
             // recycle crossfilter objects
            unregisterVisuals().then(function () {
                // clear active viz object
                cleanupSearch();
                $scope.$broadcast('directiveCleanup');
                model.resetTimer();
                return callback();
            });
        }
        c(function () {
            return deffer.resolve();
        })
        return deffer.promise;
    }
}

ctrl.$inject = ['$scope', 'generateId', '$q', '$http', 'fetchStream', '$stateParams', '$location', '$window'];
module.exports = ctrl;



/** WEBPACK FOOTER **
 ** ./src/pages/controllers/main/main.js
 **/